export default "__VITE_ASSET__BXp3Js0f__"